import React, { memo, ReactNode } from 'react';

import Input from '@plasma/ui.input.input'
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useCreateNewProjectHook from './create-new-project.hook';
import * as styled from './create-new-project.styles';
import themes from './themes';
import Button from '@plasma/ui.general.button/dist/button';
import TopBar from '../../components/top-bar/top-bar';
import Select from '@plasma/ui.input.select';


const { Option } = Select;
export interface CreateNewProjectProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = CreateNewProjectProps & ThemeOverride;

function CreateNewProject(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const {
    t,
    inputValue,
    setInputValue,
    addForm,
    cName,
    pCode,
    remarks,
    changePCode,
    changeName,
    changeRemarks,
    handleSubmit,
    handleReset,
    handleFileChange,
    handleFileUploadButton,
    isButtonEnabled,
    companyData,
    companySelectedId,
    setCompanySelectedId,
    handleTargetCompanySubmit,
    capsErrorMessage
  } = useCreateNewProjectHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.CreateNewProject className={`create-new-project ${className ?? ''}`.trim()} style={style}>

        <div style={{
                      backgroundImage: 'url(/projectBG.png)',
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      width: '100%',
                      height: '95vh',
                  }}
        >

        <TopBar topHeading={t("welcome")} headingBGColor="#ddffff" />



      <div style={{
        padding: '1vw 2vw 1vw 2vw',
        marginTop: '2vh',
        border: '1px solid white',
        width:'fit-content',
        marginLeft:'7vw',
        borderRadius: '10px',
        backgroundColor:'#ddddee66',
        boxShadow: '10px 10px 40px rgba(255, 255, 255, 01)',
        }}>

      <div style={{
       border: '1px solid lightgray',
       borderRadius: '5px',
       padding: '0vw 1vw 1vw 1vw',
       margin: '0vh 0 0 0vh',
       backgroundColor: '#ddddee',
      }}>
        <div style={{
          padding:'2px 1vw 3px 0vw',
          width:"fit-content",
          borderRadius: '5px',
          fontWeight: 'bold'
          }}>{t("select-company")}</div>
        <div style={{display: 'flex'}}>
        <Select
          placeholder={t("company-name")}
          style={{ width: '16vw', marginRight: '10px', borderRadius:'5px'}}
          value={companySelectedId}
          onChange={(e) => setCompanySelectedId(e)}
          dropdownStyle={{ maxHeight: 200, overflow: 'auto' }} // Enable scrollbar
        >
          {companyData?.map((element, index) => (
            <Option key={index} value={element.id}>
              {element.companyfullname ? element.companyfullname : element.companyname}
            </Option>
          ))}
        </Select>

          <Button
            type="primary"
            htmlType="button"
            title={t("submit")}
            style={{marginRight:'3.5vw', marginLeft:'2px'}}
            onClick={handleTargetCompanySubmit}
            disabled={companySelectedId ? false : true}
          />


        </div>

      </div>

      <div style={{
       display: 'flex',
       border: '1px solid lightgray',
       borderRadius: '5px',
       padding: '0.7vw',
       margin: '1vh 0 0 0vh',
       backgroundColor: '#ddddee',

      }}>
        <Button
          type="primary"
          title={t("create-new-project")}
          htmlType="button"
          onClick={() => addForm()}
        />

        <div style={{
          padding:'6px 1vw 3px 0vw',
          width:"fit-content",
          borderRadius: '5px',
          fontWeight: 'bold',
          marginLeft: '1vw',

          }}> </div>

        </div>


      <div>

          { inputValue && (
          <form>
            <span
              style={{
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid lightgray',
                borderRadius: '5px',
                height: 'fit-content',
                padding: '0vw 1vw 1vw 1vw',
                margin: '1vh 0 0 0vh',
                backgroundColor: '#ddddee',
              }}
            >
              <TopBar topHeading={t("create-new-project")} headingBGColor="#ffffff" showHome={false}/>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="CName" style={{ fontSize: '17px' }}>
                  {t("company-name")}{isButtonEnabled ? '':'*'}
                </label>
                <Input
                  type="text"
                  id="CName"
                  name="CName"
                  style={{
                    verticalAlign: 'middle',
                    border: `1px solid ${isButtonEnabled ? 'lightgrey':'red'}`,
                    borderBottom: '2px solid gray',
                    borderRadius: '5px',
                    height: '35px',
                    width: '450px',
                    textTransform: 'uppercase'
                  }}
                  value={cName}
                  onChange={(e) => changeName(e)}
                />


                <label htmlFor="PCode" style={{ verticalAlign: 'middle', fontSize: '17px', display: 'flex' }}>
                  {t("plant-code")}{isButtonEnabled ? '':'*'}
                  <div style={{ fontSize:'12px', }}>{capsErrorMessage !== '' ? `:${capsErrorMessage}` : ""}</div>
                </label>
                <Input
                  type="text"
                  id="PCode"
                  name="PCode"
                  style={{
                    verticalAlign: 'middle',
                    border: `1px solid ${isButtonEnabled ? 'lightgrey':'red'}`,
                    borderBottom: '2px solid gray',
                    borderRadius: '5px',
                    height: '35px',
                    width: '450px',
                    textTransform: 'lowercase'
                  }}
                  value={pCode}
                  onChange={(e) => {
                    changePCode(e);
                  }}
                />

                <label htmlFor="Remarks" style={{ verticalAlign: 'middle', fontSize: '17px' }}>
                  {t("remarks")}
                </label>
                <Input
                  type="text"
                  id="Remarks"
                  name={t("remarks")}
                  style={{
                    verticalAlign: 'middle',
                    border: '1px solid lightgray',
                    borderBottom: '2px solid gray',
                    borderRadius: '5px',
                    height: '35px',
                    width: '450px',
                  }}
                  value={remarks}
                  onChange={(e) => changeRemarks(e)}
                />


                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '10px',

                  }}
                >
                  <div>
                    <Button
                      type="primary"
                      htmlType="button"
                      title={t("reset")}
                      style={{
                        backgroundColor: !isButtonEnabled ? '#A9A9A9' : '#0000ff',
                        color: !isButtonEnabled ? 'black' : 'white',
                        padding: '0 2vw 0 2vw',
                        marginLeft: '9vw'
                      }}
                      onClick={(e) => handleReset(e)}
                      disabled={!isButtonEnabled}
                    />
                  </div>
                  <div>
                    <Button
                      type="primary"
                      disabled={!isButtonEnabled}
                      htmlType="button"
                      title={t("submit")}
                      style={{
                        backgroundColor: !isButtonEnabled ? '#A9A9A9' : '#0000ff',
                        color: !isButtonEnabled ? 'black' : 'white',
                        padding: '0 2vw 0 2vw',
                        marginLeft: '1vw'
                      }}
                      onClick={(e) => handleSubmit(e)}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderTop: '1px solid black',
                    borderBottom: '1px solid black',
                    marginTop: '1vh',
                  }}
                >
                  <div style={{padding: '1vw', display:'flex'}}>

                    <div style={{ margin: '0.2vh 0 0.2vh 0'}}>

                      <div style={{
                        fontSize: '17px',
                        textDecoration:'underline'
                        }}>{t("upload-company-logo")}</div>

                      <input
                      style={{ marginTop: '0.7vh' }}
                      type="file" accept="image/*"
                      onChange={handleFileChange} />

                    </div>

                  <Button
                    type="secondary"
                    title={t("upload-and-save")}
                    style={{margin: '2vh 0 0 0',}}
                    htmlType="button"
                    onClick={handleFileUploadButton}
                  />

                  </div>
                </div>

                <Button
                  type="primary"
                  htmlType="button"
                  title="Cancel"
                  style={{ marginTop: '2vh' }}
                  onClick={() => setInputValue(false)}
                />
              </div>
              {t("required")}
            </span>
          </form>
          )}

      </div>

    </div>
    </div>
      </styled.CreateNewProject>
    </ThemeProvider>
  );
}

export default memo(CreateNewProject) as unknown as typeof CreateNewProject;
